import React from "react";
import { createPortal } from "react-dom";
import { joinClasses } from "./ResultsPrimitives.jsx";
import { DETAIL_VIEW_TABS } from "../utils/detailViews.js";

function resolveTabCount(tabKey, { alertCount = 0, warningCount = 0 } = {}) {
  if (tabKey === "warnings") {
    return warningCount;
  }

  if (tabKey === "errors") {
    return alertCount;
  }

  return 0;
}

export default function DetailViewTabs({
  activeView = null,
  alertCount = 0,
  mountNode = null,
  onToggleView = null,
  warningCount = 0,
}) {
  if (!(mountNode instanceof HTMLElement) || typeof onToggleView !== "function") {
    return null;
  }

  const orderedTabKeys = ["warnings", "errors"];
  const tabs = [
    ...DETAIL_VIEW_TABS
      .filter((tab) => tab.key === "fleet"),
    {
      key: "route",
      label: "Route",
      panelId: "results-board",
    },
    ...orderedTabKeys
      .map((tabKey) => DETAIL_VIEW_TABS.find((tab) => tab.key === tabKey) || null)
      .filter(Boolean),
  ];

  return createPortal(
    <div className="inline-flex max-w-full flex-wrap items-center gap-1 bg-transparent p-1 shadow-none">
      {tabs.map((tab) => {
            const isRouteTab = tab.key === "route";
            const isActive = isRouteTab ? !activeView : activeView === tab.key;
            const count = resolveTabCount(tab.key, { alertCount, warningCount });
            const badgeClassName = tab.key === "warnings"
                ? "border border-[var(--dispatch-tab-warning-border)] bg-[var(--dispatch-tab-warning-fill)] text-[rgb(146_97_24)]"
                : "border border-[var(--dispatch-tab-danger-border)] bg-[var(--dispatch-tab-danger-fill)] text-[var(--dispatch-tab-danger-ink)]";

            return (
              <button
                key={tab.key}
                type="button"
                className={joinClasses([
                  "inline-flex h-8.25 min-h-8.25 items-center gap-2 rounded-[4px] px-3.5 py-1.5 text-sm font-medium transition duration-150 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2",
                  isActive
                    ? "border-0 border-b-2 border-accent bg-transparent text-accent-strong shadow-none"
                    : "border-0 border-b-2 border-transparent bg-transparent text-[rgb(59_71_68)] hover:text-accent-strong",
                ])}
                aria-controls={tab.panelId}
                aria-expanded={isActive ? "true" : "false"}
                aria-pressed={isActive ? "true" : "false"}
                onClick={() => {
                  onToggleView(isRouteTab ? null : tab.key);
                }}
              >
                <span>{tab.label}</span>
                {!isRouteTab && count > 0 ? (
                  <span className={joinClasses([
                    "inline-flex min-w-5 items-center justify-center rounded-[4px] px-1.5 text-xs font-semibold leading-5",
                    badgeClassName,
                  ])}>
                    {count}
                  </span>
                ) : null}
              </button>
            );
          })}
    </div>,
    mountNode,
  );
}
